import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-window",
  "use": "icon-window-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-window\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M11.1,7.56V9.33H8.4V12H6.6V7.56Zm1.8,8.88V14.67h2.7V12h1.8v4.44ZM19.2,5.78H4.8V18.22H19.2ZM20.1,4a.89.89,0,0,1,.9.89V19.11a.89.89,0,0,1-.9.89H3.9a.89.89,0,0,1-.9-.89V4.89A.89.89,0,0,1,3.9,4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol